import React from 'react';
import './LoginButton.css'; // Подключаем стили

const LoginButton = ({handleSelectedBlock}) => {
  return (
    <div className='login-button__container'>
      <button
        className='login-button'
        onClick={() => handleSelectedBlock('sign-in')}
      >
        Войти
      </button>
    </div>
  );
};

export default LoginButton;
